import React from 'react'
import WelcomeContainer from './WelcomeContainer'
import NavMenu from '../NavMenu'
import { Container } from "@bsf/force-ui";
import Elements from './Modules';
import ExtendWebsite from './ExtendWebsite';
import QuickAccess from './QuickAccess';
import Explore from './Explore';
import Font from './Font';
import Modules from './Modules';
import QuickSettings from './QuickSettings';
import VideoTutorials from './VideoTutorials';

const Dashboard = () => {
    return (
        <>
            <NavMenu />
            <div>
                <Container
                    align="stretch"
                    className="p-6 flex-col lg:flex-row box-border"
                    containerType="flex"
                    direction="row"
                    gap="sm"
                    justify="start"
                    style={{
                        width: "100%",
                    }}
                >
                    <Container.Item
                        className="p-2 uavc-65-width"
                        alignSelf="auto"
                        order="none"
                        shrink={0}
                    >
                        <WelcomeContainer />
                        <div className='pt-5'>
                            <QuickSettings />
                        </div>
                        <div className='pt-5'>
                            {/* <Modules /> */}
                            <VideoTutorials/>
                        </div>
                        <div className='pt-5'>
                        <Font/>
                        </div>
                    </Container.Item>
                    <Container.Item
                        className="p-2 w-full uavc-35-width"
                        shrink={1}
                    >
                        {/* <Explore /> */}
                        <div className="">
                            <QuickAccess />
                        </div>
                        <div className="pt-5">
                            <ExtendWebsite />
                        </div>
                    </Container.Item>
                </Container>
            </div>
        </>
    )
}

export default Dashboard